import React from 'react'
import { successToast, errorToast } from './FormularioUtils'

function BoxHeader({toggleModal, boxTitle, previsualizar, inputList}) {

  const validarActividad = () =>{
    if(inputList === ''){
      errorToast('Para visualizar tu actividad, asegúrate de no dejar el campo de texto vacio')
    }else if(inputList && typeof inputList !== 'string' && (inputList.length === 0 || inputList.length > inputList.filter((el)=>(el.imagen || el.texto || el.audio || el.video)).length)){
      errorToast('Para visualizar tu actividad, asegúrate de no tener renglones vacios')
    }else{
      toggleModal()
    }
  }

  return (
    <div className="flex align-center justify-between align-center pb-6">
    <p className="text-2xl text-nimbus">{boxTitle}</p>
    {previsualizar ? 
      <button onClick={validarActividad} className="border rounded-full px-3 py-2 bg-[#18bafb] text-white relative flex h-fit ml-4">
      <svg xmlns="http://www.w3.org/2000/svg" className="mr-3 w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
        Previsualizar
      </button>:''}
    </div>
  )
}

BoxHeader.defaultProps = {
  boxTitle:'Actividad',
  previsualizar:true,
}

export default BoxHeader